import angular from "angular";
import template from "./admin-campus-create-zone.html";
import AdminSchoolLocationZoneCreateController from "./admin-campus-create-zone.controller";

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.admin.schools.view.locations.zones.create", {
    url: "/:locationId/create",
    controller: AdminSchoolLocationZoneCreateController,
    controllerAs: "vm",
    template: template,
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.administrator,
        USER_ROLES.owner,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.dashboard.schools.view.locations.zones.create", [])
  .config(config)
  .controller(
    "AdminSchoolLocationZoneCreateController",
    AdminSchoolLocationZoneCreateController,
  );
